import I18n from "../../I18n";
import { datetime, date } from "../../utils";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { generateFindingColumn } from "../../utils/dataFileEnum";
import { getFileSubmittedStatus, getMergeStatus, getFileStatus } from "../../utils/dataFileStage";

const mapCard = (json, modules) => {
    const {
        id,
        name,
        status,
        uploadedAt,
        startDate,
        endDate,
        submittedBy,
        statusCode,
        internalStatus,
        fileSubmittedAt,
        fileSubmittedBy,
        fiscalYear,
        type,
        subType,
    } = json;
    const { mergeStatusMessage, family } = getMergeStatus(internalStatus);
    const { color, statusFamily } = getFileStatus(status);
    const hasFindings = generateFindingColumn(statusCode, status, I18n, fiscalYear, id);
    const haveModuleSubmissionFile = modules.includes("submission_file");

    const isFileSubmitted = internalStatus ? 1 : 0;

    const propsSubmissionFile = haveModuleSubmissionFile
        ? [
              [
                  {
                      labels: ["File Submitted"],
                      value: {
                          ...getFileSubmittedStatus(isFileSubmitted),
                          value: isFileSubmitted ? I18n.translate`Yes` : I18n.translate`No`,
                          label: isFileSubmitted ? I18n.translate`Yes` : I18n.translate`No`,
                      },
                  },
              ],
              [
                  {
                      labels: ["File Submitted By"],
                      value: fileSubmittedBy || "N/A",
                      type: "string",
                      mobileHidden: true,
                  },
              ],
              [
                  {
                      labels: ["File Submitted At"],
                      value: datetime(fileSubmittedAt) || "N/A",
                      type: "datetime",
                      mobileHidden: true,
                  },
              ],
          ]
        : [];

    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
                align: "left",
                basis: "10%",
            },
        ],
        [{ labels: ["File"], value: name, type: "string", align: "left" }],
        [
            {
                labels: ["fiscalYear"],
                value: fiscalYear,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["uploaded"],
                value: datetime(uploadedAt),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["type"],
                value: I18n.translate`${type}`,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["subtype"],
                value: subType,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["start"],
                value: date(startDate),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["end"],
                value: date(endDate),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["user"],
                value: submittedBy,
                type: "string",
                align: "left",
                mobileHidden: true,
            },
        ],
        [
            {
                value: {
                    severity: 4,
                    value: I18n.translate`${mergeStatusMessage}`,
                    label: I18n.translate`${mergeStatusMessage}`,
                    family: family || "text",
                    color: "main",
                },
            },
        ],
        [hasFindings],
        ...propsSubmissionFile,
        [
            {
                value: {
                    severity: 4,
                    value: I18n.translate`${status}`,
                    label: I18n.translate`${status}`,
                    family: statusFamily || "text",
                    color: color,
                },
            },
        ],
    ];
};

const mapper = (json, card, details, locale, entity, modules) => {
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json, modules) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/folders/${json.id}?filter=${stringifyFilter(
                [{ column: "ID", filters: [{ value: `${json.id}` }] }],
            )}`,
        },
    };
};

const header = (headerItems, modules) => {
    const haveModuleSubmissionFile = modules.includes("submission_file");

    const propsSubmissionFile = haveModuleSubmissionFile
        ? [
              {
                  label: ["File Submitted"],
                  align: "left",
                  mobileHidden: true,
                  type: "stringWithColor",
              },
              { label: ["File Submitted By"], align: "left", mobileHidden: true },
              { label: ["File Submitted At"], align: "left", mobileHidden: true },
          ]
        : [];
    return [
        { label: ["Id"], align: "left", basis: "10%" },
        { label: ["File"], align: "left", columnName: "name", sortable: true },
        {
            label: ["Fiscal Year"],
            align: "center",
            columnName: "fiscal_year",
            sortable: true,
        },
        {
            label: ["Uploaded at"],
            align: "center",
            mobileHidden: true,
            columnName: "uploaded_at",
            sortable: true,
        },
        {
            label: ["Type"],
            align: "left",
            mobileHidden: true,
            columnName: "type",
            sortable: true,
        },
        {
            label: ["Sub Type"],
            align: "left",
            mobileHidden: true,
            columnName: "sub_type",
            sortable: true,
        },
        { label: ["Start Date"], align: "center", mobileHidden: true },
        { label: ["End Date"], align: "center", mobileHidden: true },
        { label: ["Uploaded by"], align: "left", mobileHidden: true },
        {
            label: ["Merge Status"],
            align: "left",
            mobileHidden: true,
            columnName: "internal_status",
            sortable: true,
            type: "status",
        },
        { label: ["Findings"], align: "center", type: "repoHasFindings" },
        ...propsSubmissionFile,
        { label: ["Status"], align: "left", sortable: true, type: "status" },
    ];
};

const datafileMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};

export default datafileMapper;
